// Only these stream events can change persisted state. Chunks and
// activity_update progress prose never do, so pages must not refetch on them.

import { type OrganizationEvent } from '@apps/web/hooks/use_organization_events';

type AgentStreamEvent = Extract<
    OrganizationEvent,
    {
        readonly type:
            | 'agent_run_stream_event'
            | 'agent_conversation_stream_event';
    }
>;

const STATE_CHANGING_AGENT_STREAM_EVENT_TYPES: ReadonlySet<
    AgentStreamEvent['data']['type']
> = new Set(['run_started', 'run_complete', 'run_error', 'tool_call_complete']);

export function isStateChangingAgentStreamEvent(
    event: OrganizationEvent,
): boolean {
    if (
        event.type !== 'agent_run_stream_event' &&
        event.type !== 'agent_conversation_stream_event'
    ) {
        return false;
    }
    return STATE_CHANGING_AGENT_STREAM_EVENT_TYPES.has(event.data.type);
}
